import React, { useCallback, useState } from 'react';
import history from 'helpers/history';
import useUnlockAchievements from 'components/Achievements/useUnlockAchievements';
import LoyaltyProgram from 'components/LoyaltyProgram';
import LoyaltyAchievements from 'components/Achievements/LoyaltyAchievements';

const Loyalty = () => {
  const isUnlocking = useUnlockAchievements();
  const goToDashboard = useCallback(() => history.push('/'), []);
  const [loyaltyProgram, setLoyaltyProgram] = useState(null);

  return (
    <div className="loyalty-page">
      <LoyaltyProgram onLoaded={setLoyaltyProgram} />
      <LoyaltyAchievements
        isUnlocking={isUnlocking}
        onLocked={goToDashboard}
        loyaltyProgram={loyaltyProgram}
      />
    </div>
  );
};

export default Loyalty;
